<template>
  <full-page-alert :model-value="!!reloadPageAlert" @update:model-value="onUpdateModelValue">
    <page-content-placeholder
      :text="reloadPageAlert?.title"
      :img-src="reloadPageAlert?.icon || PlaceholderImg"
      max-width="640px"
    >
      <div class="paragraph-m_h mt-1" v-html="reloadPageAlert?.subtitle" />
      <e-btn prepend-icon-src="refresh" variant="primary" class="mt-6" :loading="isReloading" @click="reloadPage">
        Обновить страницу
      </e-btn>
    </page-content-placeholder>
  </full-page-alert>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import PlaceholderImg from '@/assets/img/layouts/time-expired.svg';
import FullPageAlert from '@/core/components/common/FullPageAlert.vue';
import PageContentPlaceholder from '@/core/components/common/PageContentPlaceholder.vue';
import { EBtn } from '@/core/components/ui';
import { useAppState } from '@/core/store/useAppState';

const { reloadPageAlert } = useAppState();

const isReloading = ref(false);

const reloadPage = async () => {
  isReloading.value = true;

  if (reloadPageAlert.value?.action) {
    await reloadPageAlert.value.action();
    reloadPageAlert.value = null;
  } else {
    location.reload();
  }

  isReloading.value = false;
};

const onUpdateModelValue = (value: boolean | undefined) => {
  if (!value) {
    reloadPageAlert.value = null;
  }
};
</script>
